import { Stack } from '@mui/material';
import { DataGrid, GridRowClassNameParams, GridSortModel } from '@mui/x-data-grid';
import CustomDataGridSlots from 'components/data-grid/CustomDataGridSlots';
import HeaderWithSearchBar from 'components/HeaderWithSearchBar';
import { PrivateChatBulkMessageStatus } from 'enums';
import { useIsMobile } from 'hooks';
import { ScrollAreaLayout } from 'layout';
import { bulkMessagesTableConfig } from 'pages/app-pages/private-bulk-message-page/bulkMessagesTableConfig';
import SortByMessages from 'pages/app-pages/private-bulk-message-page/SortByMessages';
import { tableStyle } from 'style';
import { PrivateChatBulkMessage } from 'types';

interface MessagesTableProps {
  drawerIsOpen: boolean;
  toggleDrawer: () => void;
  messages: PrivateChatBulkMessage[];
  isLoading: boolean;
  sortModel: GridSortModel;
  onSortModelChange: (newSortModel: GridSortModel) => void;
  onCreateMessage: () => void;
  handleSearchChange: (value: string) => void;
  search: string;
}

const MessagesTableWrapper = ({
  messages,
  isLoading,
  sortModel,
  handleSearchChange,
  search,
  onCreateMessage,
  onSortModelChange,
}: MessagesTableProps) => {
  const { isSmallMobile } = useIsMobile();

  return (
    <Stack px={{ xs: 2, md: 3 }}>
      <HeaderWithSearchBar
        mainAction={{
          label: 'Create Message',
          icon: 'add',
          onClick: onCreateMessage,
        }}
        /*  secondaryAction={{
          label: 'Manage Recipients',
          icon: 'groups',
          onClick: toggleDrawer,
        }} */
        sortModel={sortModel}
        onSortModelChange={onSortModelChange}
        handleSearchChange={handleSearchChange}
        search={search}
        headerText='Scheduled Messages'
        SortBy={SortByMessages}
      />
      <ScrollAreaLayout subtract={isSmallMobile ? 130 : 160}>
        <DataGrid
          sortModel={sortModel}
          onSortModelChange={onSortModelChange}
          sortingOrder={['asc', 'desc']}
          rows={messages}
          loading={isLoading}
          columns={bulkMessagesTableConfig}
          rowHeight={70}
          disableRowSelectionOnClick
          disableColumnMenu
          sx={tableStyle({ clickable: false })}
          slots={CustomDataGridSlots({
            noRowsOverlayProps: {
              onClick: onCreateMessage,
              buttonTitle: 'Create Message',
            },
          })}
          getRowClassName={(params: GridRowClassNameParams<PrivateChatBulkMessage>) => {
            if (params.row.error) {
              return 'error-row';
            }
            if (
              params.row.sendAttempt &&
              params.row.status !== PrivateChatBulkMessageStatus.Draft
            ) {
              return 'sent-row';
            }
            if (params.row.status === PrivateChatBulkMessageStatus.Draft) {
              return 'draft-row';
            }
            return 'message-row';
          }}
        />
      </ScrollAreaLayout>
    </Stack>
  );
};

export default MessagesTableWrapper;
